module.exports = __webpack_public_path__ + "static/img/p2-projects-2.5b75a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/p2-projects-2.png
// module id = E7m2
// module chunks = 1